export enum fields {
  SENDER = "sender",
  DESTINATION = "destination",
  STATUS = "statusId",
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt"
}
